import React, { useEffect, useState, useRef } from "react";
import {
  PatternlibButton,
  PatternlibIcon,
  PatternlibOverlayContainer,
  PatternlibTextlink,
  PatternlibPill,
} from "@liebherr/patternlib-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./BackButton.module.css";
import PropTypes from "prop-types";

const BackButton = ({ preventGoingBack, url, noState, isDemoUser }) => {
  const overlayRef = useRef();
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onButtonClick = () => {
    if (!noState) {
      if (preventGoingBack) {
        setShow(true);
      } else {
        navigate(url);
      }
    }
  };

  const onConfirm = () => {
    setShow(false);
    navigate(url);
  };

  const onClose = () => {
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      // Select content class and add style
      const ref = overlayRef.current;
      const element = ref.shadowRoot.querySelector(".content");
      element.style.zIndex = "9999";
    }
  }, [show]);

  useEffect(() => {
    const ref = overlayRef.current;
    const onCloseListener = () => {
      setShow(false);
    };
    // attach the event to the component
    ref.addEventListener("lhClose", onCloseListener, false);
    // remove event on component unmount
    return () => {
      ref.removeEventListener("lhClose", onCloseListener, true);
    };
  }, [overlayRef]);

  return (
    <div className={styles.overlayContainer}>
      <PatternlibButton type="secondary" width="60px" onClick={onButtonClick}>
        <span slot="icon">
          <PatternlibIcon
            icon-name="font-arrow"
            size="28px"
            className={styles.rotate180}
          ></PatternlibIcon>
        </span>
      </PatternlibButton>
      {isDemoUser && (
        <div className={styles.demoBadge}>
          <PatternlibPill no-states label="Demo-Mode"></PatternlibPill>
        </div>
      )}
      <PatternlibOverlayContainer target="center" show={show} ref={overlayRef}>
        <div slot="content" className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h2>{t("GoBackModal.preventGoingBackTitle")}</h2>
            <div className={styles.closeIcon}>
              <PatternlibIcon icon-name="x" onClick={onClose}></PatternlibIcon>
            </div>
          </div>
          <span>{t("GoBackModal.preventGoingBackText")}</span>
          <div className={styles.modalFooter}>
            <PatternlibTextlink
              label={t("GoBackModal.cancelButton")}
              size="small"
              onClick={onClose}
            ></PatternlibTextlink>
            <PatternlibButton
              label-text-align="left"
              icon-position="right"
              label={t("GoBackModal.preventGoingBackConfirmButton")}
              size="small"
              onClick={onConfirm}
            ></PatternlibButton>
          </div>
        </div>
      </PatternlibOverlayContainer>
    </div>
  );
};

BackButton.propTypes = {
  preventGoingBack: PropTypes.bool,
  url: PropTypes.string,
  noState: PropTypes.bool,
};

BackButton.defaultProps = {
  preventGoingBack: true,
  url: "/",
  noState: false,
};

export default BackButton;
